(function () {
  'use strict';
  var scheduled = false;

  function amsterdamDateKey() {
    try {
      var parts = new Intl.DateTimeFormat('en', {
        timeZone: 'Europe/Amsterdam',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).formatToParts(new Date());
      var values = {};
      parts.forEach(function (part) { values[part.type] = part.value; });
      return values.year + '-' + values.month + '-' + values.day;
    } catch (error) {
      var now = new Date();
      var year = now.getFullYear();
      var month = String(now.getMonth() + 1).padStart(2, '0');
      var day = String(now.getDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    }
  }

  function isActive(releaseDate) {
    return /^\d{4}-\d{2}-\d{2}$/.test(releaseDate || '') && releaseDate > amsterdamDateKey();
  }

  function syncElement(element) {
    var releaseDate = element.getAttribute('data-preorder-release');
    var active = isActive(releaseDate);
    var role = element.getAttribute('data-preorder-role');

    if (role === 'notice' || role === 'cart-badge') {
      element.hidden = !active;
      return;
    }
    if (role === 'line-property') {
      element.disabled = !active;
      return;
    }
    if (role === 'accelerated') {
      var canAdd = element.getAttribute('data-preorder-can-add') === 'true';
      element.hidden = active || !canAdd;
      return;
    }
    if (role === 'button') {
      var target = element.querySelector('[data-preorder-label-target]') ||
        element.querySelector('.add-to-cart-text__content') ||
        element.querySelector('.add-to-cart-text');
      if (!target) return;

      var preorderLabel = element.getAttribute('data-preorder-label');
      var normalLabel = element.getAttribute('data-preorder-normal-label');
      if (!preorderLabel || !normalLabel) return;

      if (active && !element.disabled && !element.classList.contains('sold-out--button')) {
        if (target.textContent.trim() !== preorderLabel) target.textContent = preorderLabel;
        element.setAttribute('data-preorder-active', 'true');
      } else {
        if (!active && target.textContent.trim() === preorderLabel) target.textContent = normalLabel;
        element.removeAttribute('data-preorder-active');
      }
    }
  }

  function sync(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('[data-preorder-release]')) syncElement(scope);
    scope.querySelectorAll('[data-preorder-release]').forEach(syncElement);
  }

  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      sync(document);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    sync(document);
    var observer = new MutationObserver(scheduleSync);
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled', 'class', 'hidden']
    });
  });

  document.addEventListener('submit', function (event) { sync(event.target); }, true);
  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('shopify:section:reorder', scheduleSync);
  document.addEventListener('product:variant-change', scheduleSync);
  document.addEventListener('variant:change', scheduleSync);
})();
